import React from 'react';

function Calendar() {
    return (
        <div>
            <h1>Calendar</h1>
        </div>
    )
}
export default Calendar;